import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import LoadingSpinner from "../../Components/spinner";
import { useSearchParams } from "react-router-dom";

const ProvinceFilters = ({
  pagination,
  setPagination,
  query,
  setQuery,
  filters,
  setFilters,
  setProvinces,
  fetchProvinces,
  filtering,
  setFiltering,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getFilteredProvinces = async (e) => {
    const value = e.target.value;
    const params = new URLSearchParams(searchParams);
    if (value && value !== "3") {
      params.set("status", value);
    } else {
      params.delete("status");
    }
    params.set("page", 1);
    setSearchParams(params);
  };

  // // // Reset All Filters to default
  const resetFilters = async () => {
    setSearchParams({});
  };

  // // // Search by name
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const params = new URLSearchParams(searchParams);
      if (query) {
        params.set("search", query);
      } else {
        params.delete("search");
      }
      params.set("page", 1);
      setSearchParams(params);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  return (
    <div className="col-md-10 row">
      <div className="col-md-3 py-2">
        <Form.Control
          type="text"
          placeholder="Search Provinces..."
          value={query}
          onChange={(e) => {
            handleSearch(e);
          }}
          className="bg-dark text-light border-light input-placeholder-light"
        />
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="status"
          value={filters}
          onChange={(e) => {
            getFilteredProvinces(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="3">Active & Inactive</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
          <option className="text-danger" value="2">
            Deleted
          </option>
        </Form.Select>
      </div>
      <div className="col-md-1 py-2 mx-2">
        {filtering ? (
          <LoadingSpinner size={"md"} />
        ) : (
          <div className="row ">
            <Button
            title="Reset Filters And Rrfresh Records"
              className="btn btn-success"
              onClick={() => {
                resetFilters();
              }}
            >
              Reset
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProvinceFilters;
